import { c as _c } from "react/compiler-runtime";
import { client } from "../../../shared/utils/thirdweb.js";
import createDebug from "debug";
import { sendTransaction } from "thirdweb";
import { addSessionKey } from "thirdweb/extensions/erc4337";
import { useActiveAccount } from "thirdweb/react";
const debug = createDebug("@@b3:useHandleTWConnect");
export function useAddTWSessionKey(t0) {
  const $ = _c(8);
  const {
    onSuccess,
    onError,
    refetchSigners,
    chain
  } = t0;
  if (!chain) {
    throw new Error("Chain is required");
  }
  const account = useActiveAccount();
  let t1;
  if ($[0] !== account || $[1] !== chain || $[2] !== onError || $[3] !== onSuccess || $[4] !== refetchSigners) {
    t1 = async t2 => {
      const {
        sessionKeyAddress,
        approvedTargets,
        nativeTokenLimitPerTransaction,
        permissionStartTimestamp,
        permissionEndTimestamp
      } = t2;
      if (!account || !chain) {
        return;
      }
      debug("@@newSessionKey:", {
        sessionKeyAddress,
        approvedTargets,
        nativeTokenLimitPerTransaction,
        permissionStartTimestamp,
        permissionEndTimestamp
      });
      ;
      try {
        const transaction = addSessionKey({
          contract: {
            client,
            chain,
            address: account.address
          },
          account,
          sessionKeyAddress,
          permissions: {
            approvedTargets,
            nativeTokenLimitPerTransaction,
            permissionStartTimestamp,
            permissionEndTimestamp
          }
        });
        debug("@@ecosystem:newSessionKey:transaction:", transaction);
        const transactionResult = await sendTransaction({
          transaction,
          account
        });
        debug("@@ecosystem:newSessionKey:transactionResult:", transactionResult);
        onSuccess(transactionResult);
        await refetchSigners();
      } catch (t3) {
        const error = t3;
        onError(error);
        console.error("@@ecosystem:newSessionKey:error:", error);
      }
    };
    $[0] = account;
    $[1] = chain;
    $[2] = onError;
    $[3] = onSuccess;
    $[4] = refetchSigners;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const newSessionKey = t1;
  let t2;
  if ($[6] !== newSessionKey) {
    t2 = {
      newSessionKey
    };
    $[6] = newSessionKey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}